'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _odataFilterBuilder = require('odata-filter-builder');

var _odataFilterBuilder2 = _interopRequireDefault(_odataFilterBuilder);

var _query = require('utilities/query');

var _reportForm = require('./report-form.html');

var _reportForm2 = _interopRequireDefault(_reportForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _reportForm2.default,
  bindings: {
    onReportGenerated: '&'
  },
  controller: function () {
    function ReportFormComponent(EventEmitter, AnimalTypeService, CategoryService, CompanyService, IngredientService, ProductService, ReportService, SessionService, ToastService) {
      'ngInject';

      _classCallCheck(this, ReportFormComponent);

      Object.assign(this, {
        EventEmitter: EventEmitter,
        AnimalTypeService: AnimalTypeService,
        CategoryService: CategoryService,
        CompanyService: CompanyService,
        IngredientService: IngredientService,
        ProductService: ProductService,
        ReportService: ReportService,
        SessionService: SessionService,
        ToastService: ToastService
      });
    }

    _createClass(ReportFormComponent, [{
      key: '$onInit',
      value: function $onInit() {
        var _this = this;

        this.params = this.SessionService.reportParams || {};
        this.params.ingredientIds = this.params.ingredientIds || [];
        this.params.memberIds = this.params.memberIds || [];
        this.params.productIds = this.params.productIds || [];

        this.CategoryService.search({
          orderBy: 'ProductCategoryName',
          direction: 'asc'
        }).then(function (r) {
          _this.categories = (0, _query.transformODataResponse)(r).Data;
        }).catch(function (error) {
          return _this.ToastService.showError(error);
        });

        this.AnimalTypeService.getAnimalTypes().then(function (r) {
          _this.animalTypes = r.data;
        }).catch(function (error) {
          return _this.ToastService.showError(error);
        });

        this.years = this.ReportService.getYears();
      }
    }, {
      key: 'transformChip',
      value: function transformChip(chip) {
        if (_angular2.default.isObject(chip)) {
          return chip;
        }

        return { name: chip, type: 'new' };
      }
    }, {
      key: 'searchMembers',
      value: function searchMembers(memberName) {
        var _this2 = this;

        return this.CompanyService.search({
          orderBy: 'MemberName',
          direction: 'asc',
          filter: (0, _odataFilterBuilder2.default)().contains('MemberName', memberName)
        }).then(function (r) {
          return (0, _query.transformODataResponse)(r).Data;
        }).catch(function (error) {
          return _this2.ToastService.showError(error);
        });
      }
    }, {
      key: 'searchProducts',
      value: function searchProducts(productName) {
        var _this3 = this;

        return this.ProductService.search({
          orderBy: 'ProductName',
          direction: 'asc',
          filter: (0, _odataFilterBuilder2.default)().contains('ProductName', productName)
        }).then(function (r) {
          return (0, _query.transformODataResponse)(r).Data;
        }).catch(function (error) {
          return _this3.ToastService.showError(error);
        });
      }
    }, {
      key: 'searchIngredients',
      value: function searchIngredients(ingredientName) {
        var _this4 = this;

        return this.IngredientService.searchSystemIngredients({
          orderBy: 'SystemIngredientName',
          direction: 'asc',
          filter: (0, _odataFilterBuilder2.default)().contains('SystemIngredientName', ingredientName)
        }).then(function (r) {
          return (0, _query.transformODataResponse)(r).Data;
        }).catch(function (error) {
          return _this4.ToastService.showError(error);
        });
      }
    }, {
      key: 'resetForm',
      value: function resetForm() {
        this.reportForm.$setPristine();
        this.reportForm.$setUntouched();
        this.params = {};
        this.params.ingredientIds = [];
        this.params.memberIds = [];
        this.params.productIds = [];
        this.persistParams();
      }
    }, {
      key: 'persistParams',
      value: function persistParams() {
        this.SessionService.reportParams = this.params;
      }
    }, {
      key: 'onSubmit',
      value: function onSubmit(params) {
        this.persistParams();
        this.onReportGenerated(this.EventEmitter({
          params: _extends({}, params, {
            ingredientIds: params.ingredientIds && params.ingredientIds.map(function (ingredient) {
              return ingredient.SystemIngredientId;
            }) || [],
            productIds: params.productIds && params.productIds.map(function (product) {
              return product.ProductId;
            }) || [],
            memberIds: params.memberIds && params.memberIds.map(function (product) {
              return product.MemberId;
            }) || []
          })
        }));
      }
    }, {
      key: 'toggleYears',
      value: function toggleYears() {
        if (this.allYearsSelected) {
          this.allYearsSelected = false;
          this.params.yearIds = [];
        } else {
          this.allYearsSelected = true;
          this.params.yearIds = this.years;
        }
      }
    }, {
      key: 'toggleCategories',
      value: function toggleCategories() {
        if (this.allCategoriesSelected) {
          this.allCategoriesSelected = false;
          this.params.productCategoryIds = [];
        } else {
          this.allCategoriesSelected = true;
          this.params.productCategoryIds = this.categories.map(function (c) {
            return c.ProductCategoryId;
          });
        }
      }
    }, {
      key: 'toggleSpecies',
      value: function toggleSpecies() {
        if (this.allSpeciesSelected) {
          this.allSpeciesSelected = false;
          this.params.specieIds = [];
        } else {
          this.allSpeciesSelected = true;
          this.params.specieIds = this.animalTypes.map(function (c) {
            return c.AnimalTypeId;
          });
        }
      }
    }]);

    return ReportFormComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/reports/report-form/report-form.component.js